import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Department')
export class Department {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String)
    name = '';
}